module.exports = __webpack_public_path__ + "img/yellow-marker.e14e877d.svg";